// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".disable{cursor:not-allowed}\n", "",{"version":3,"sources":["/app/src/component/specific/otpTimer/otpTimer.scss"],"names":[],"mappings":"AAAA,SACE,kBAAmB","file":"otpTimer.scss","sourcesContent":[".disable {\n  cursor: not-allowed;\n}\n"]}]);
// Exports
module.exports = exports;
